import { createFileRoute } from "@tanstack/react-router";
import FounderDashboard from "@/pages/FounderDashboard";

export const Route = createFileRoute("/accelerator/")({
  component: FounderDashboard,
});
